<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <router-link to="/" class="logo-text-link">
        <span class="logo-title">织歌</span>
        <span class="logo-subtitle">专注水泥级防水</span>
      </router-link>
    </div>
    <div class="footer-divider"></div>
    <p class="title">新化县盾甲防水有限公司</p>
    <p class="address_tel_fax">
      <span>地址：湖南省娄底市新化县上梅街道立新桥社区城西路108号</span>
      <span>Tel：155 7630 1537</span>
    </p>
    <p class="email_wx">
      <!-- <span>邮箱：xxx@163.com</span> -->
      <span>微信号：wxid_ndkf3a3vnw4x22</span>
    </p>
    <p class="copy">
      Copyright &copy; 2018 - {{ new Date().getFullYear() }} 新化县盾甲防水有限公司
    </p>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}

/* logo 文字 */
.logo {
  margin: 24px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo .logo-text-link {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: opacity 0.3s ease;
}
.logo .logo-text-link:hover {
  opacity: 0.85;
}
.logo .logo-title {
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 8px;
  line-height: 1.2;
}
.logo .logo-subtitle {
  font-size: 12px;
  font-weight: 400;
  color: #d3d3d3;
  letter-spacing: 3px;
  line-height: 1.4;
  margin-top: 4px;
}

/* 分隔线 */
.footer-divider {
  width: 60px;
  height: 2px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 1px;
  margin: 10px auto 0;
}

.title {
  font-size: 20px;
  margin: 14px 0 10px;
  letter-spacing: 2px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 6px 0;
  letter-spacing: 0.5px;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
  letter-spacing: 0.5px;
}
.copy {
  color: #999;
  font-size: 13px;
  margin: 24px 0 16px;
  letter-spacing: 0.5px;
}
@media screen and (max-width: 997px) {
  .logo {
    margin: 18px auto 0;
  }
  .logo .logo-title {
    font-size: 24px;
    letter-spacing: 5px;
  }
  .logo .logo-subtitle {
    font-size: 10px;
  }
  .footer-divider {
    width: 40px;
    margin: 14px auto 0;
  }
  .title {
    font-size: 18px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue